import PropTypes from "prop-types";
import EditButtonHover from "src/components/buttons/EditButtonHover";

export default function GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv({
  title = "",
  Icon = null,
  ButtonIcon = null,
  onAddClick,
  size = "medium", // small, medium, large
  tooltipProps = {
    placement: "left",
    title: "",
  },
}) {
  const fontSize = size === "large" ? "1.3em" : size === "small" ? "1em" : "1.15em";
  return (
    <div className="newKeikka_header">
      <EditButtonHover
        disabled={onAddClick === undefined}
        onClick={onAddClick}
        size="small"
        tooltipProps={tooltipProps}
        overlapButton={true}
        ButtonIcon={ButtonIcon}>
        <div className="newKeikka_title" style={{ fontSize: fontSize }}>
          <Icon /> {title}
        </div>
      </EditButtonHover>
    </div>
  );
}

GridKeikka_NewKeikka_AsiakasSelector_HeaderDiv.propTypes = {
  title: PropTypes.string,
  Icon: PropTypes.elementType,
  ButtonIcon: PropTypes.elementType,
  onAddClick: PropTypes.func,
  size: PropTypes.string,
  tooltipProps: PropTypes.object,
};
